module.exports = __webpack_public_path__ + "img/w3_phone_black.2e6c5f4a.png";